import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=382f74f4&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/case.css?vue&type=style&index=0&id=382f74f4&scoped=true&lang=css&"
import style1 from "../../assets/css/article.css?vue&type=style&index=1&id=382f74f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382f74f4",
  null
  
)

export default component.exports